import { 
	createSlice,
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'
import {
	setCurrentUser
} from '../features/users/usersSlice'
import {envAwarePost} from '../util/util'

export const disableOnboarding = createAsyncThunk(
	'onboarding/disable',
	async => envAwarePost('api/help/api/',{
		action:'disableOnboarding',
	})
)


const slice = createSlice({
	name: 'onboarding',
	initialState:{
		status:'pending',
	},
	reducers: {
		toggleFirstLogin:(state,action)=>{
			state.firstLogin.show ^= 1
		},
		setOnboarding:(state,action)=>{
			const {
				first_login,
				generic_program_automation
			} = action.payload
			state.firstLogin = first_login
			state.genericProgramAutomation = generic_program_automation
			state.status = 'idle'
		}
	},
	extraReducers:{
		[disableOnboarding.pending]:state=>{
			state.firstLogin.show = 0
			state.genericProgramAutomation.show = 0
		},
	}
})

export const {setOnboarding,toggleFirstLogin} = slice.actions

export default slice.reducer